import { PlannerProfileListSearchCriteria } from '../../../../../models/planner-profile.model';

export class FailedMessagesProfileListLoad {
  public static readonly type = '[FailedMessagesProfileList] Load';
  constructor(public payload: PlannerProfileListSearchCriteria) {}
}

export class FailedMessagesProfileListInitialState {
  public static readonly type = '[FailedMessagesProfileList] Set Initial State';
}
